import React, { useState, useEffect, Suspense, useMemo, useContext } from "react";
import { useLocation } from "react-router";
import { Switch, Redirect, Route } from "react-router-dom";
import styled from "styled-components";
import { Layout, Skeleton, Row, Col } from "antd";

import { clientUrls } from "misc/urls";
import { LoggedInUserContext } from "context/LoggedInUserContext";
import { Card } from "misc/card";
import { Result } from "misc/results";

import { Footer } from "navigation/Footer";
import Header from "navigation/header/Header";
import SidebarWeb from "navigation/Sidebar/SidebarWeb";
import SidebarMobile from "navigation/Sidebar/SidebarMobile";
import UserContainer from "admin/UserContainer";
import CustomerContainer from "admin/CustomerContainer";
import RolesContainer from "admin/RolesContainer";

// Lazy load not often used domponents
const SettingsContainer = React.lazy(() => import("settings/containers/SettingsContainer"));

const { Content } = Layout;

const MainContent = styled(Content)`
    padding: 25px 15px;
`;

const RootAuthenticated = () => {
    const location = useLocation();
    const { hasAuthorityFull, hasAuthorityLocalAdmin } = useContext(LoggedInUserContext);

    const hasAuthority = useMemo(() => {
        return hasAuthorityFull() || hasAuthorityLocalAdmin();
    }, [hasAuthorityFull, hasAuthorityLocalAdmin]);

    const [windowSize, setWindowSize] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener("resize", () => setWindowSize(window.innerWidth));
        return () => window.removeEventListener("resize", () => setWindowSize(window.innerWidth));
    }, [windowSize]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const fullAdminRoutes = useMemo(() => {
        if (hasAuthorityFull()) {
            return [
                <Route key="customers" path={clientUrls.customers.baseUrl()}>
                    <CustomerContainer />
                </Route>,
                <Route key="roles" path={clientUrls.roles.baseUrl()}>
                    <RolesContainer />
                </Route>
            ];
        }
        return null;
    }, [hasAuthorityFull]);

    return (
        <Row justify="center">
            <Col span={24} style={{ maxWidth: 1920, minHeight: "100vh" }}>
                <Layout>
                    <Header />
                    <Layout>
                        {windowSize > 768 ? <SidebarWeb /> : <SidebarMobile />}
                        <MainContent>
                            {!hasAuthority ? (
                                <Row justify="center">
                                    <Col span={24} style={{ maxWidth: 1920, minHeight: "100vh" }}>
                                        <Card>
                                            <Result type="unauthorizedAccess" />
                                        </Card>
                                    </Col>
                                </Row>
                            ) : (
                                <Suspense
                                    fallback={
                                        <div style={{ paddingRight: 30 }}>
                                            <Skeleton paragraph={{ rows: 4 }} />
                                        </div>
                                    }
                                >
                                    {/* TODO: Add roles */}

                                    <Switch>
                                        <Route exact path="/" component={UserContainer} />
                                        <Route path={clientUrls.users.baseUrl()} component={UserContainer} />
                                        <Route path={clientUrls.header.settings()} component={SettingsContainer} />
                                        {fullAdminRoutes}
                                        <Route path="*">
                                            <Redirect to="/" />
                                        </Route>
                                    </Switch>
                                </Suspense>
                            )}
                            <Footer />
                        </MainContent>
                    </Layout>
                </Layout>
            </Col>
        </Row>
    );
};

export default RootAuthenticated;
